import { Badge, Box, Modal } from "@mui/material";
import { observer } from "mobx-react";
import { LiveScoreResult, liveScoreStore } from "../Stores/liveScoreStore";
import FlashIcon from "../Assets/Icons/flash.png";
import React, { useEffect, useState } from "react";
import { LogRow } from "../Model/log";
import { ScorePicker } from "../Components/Dialog/numberPicker";

const _MultiLiveScoreUpdater: React.FC = () => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <Badge
        badgeContent={`${liveScoreStore.logResults.length}`}
        color="warning"
        style={{ cursor: "pointer" }}
      >
        <img src={FlashIcon} height={25} onClick={() => setOpen(true)} />
      </Badge>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Box sx={style}>
          <div
            style={{ display: "flex", flexFlow: "column", textAlign: "center" }}
          >
            <h2>Live Games</h2>
            <label>All live games</label>
            <div
              style={{
                display: "flex",
                flexFlow: "column",
                height: "95%",
                overflowY: "scroll",
              }}
            >
              {liveScoreStore.logResults.map((row, index) => (
                <ResultRow game={row} key={index} />
              ))}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

const ResultRow: React.FC<{ game: LiveScoreResult }> = ({ game }) => {
  const [countdown, setCountdown] = useState(-1); //fiveSeconds

  const deleteGame = () => {
    liveScoreStore.deleteGame(game.id);
  };

  //this will be for countdown to delete as a form of caution.
  const initCountdown = () => {
    setCountdown(5000); //start with 5 seconds
  };

  useEffect(() => {
    if (countdown > -1) {
      const interval = setInterval(() => {
        if (countdown > 0) {
          setCountdown((prevSeconds) => prevSeconds - 500);
          console.log(countdown);
        } else {
          clearInterval(interval);
          // You can add logic here for when the countdown finishes
          console.log("Countdown finished!");
          deleteGame();
        }
      }, 100);

      // Cleanup function to clear the interval when the component unmounts
      return () => clearInterval(interval);
    }
  }, [countdown]); // Re-run effect if seconds changes (though in this case, it's for cleanup)

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "row",
        padding: 10,
        background: "whitesmoke",
        marginBottom: "10px",
        textAlign: "center",
      }}
    >
      <div style={{ width: "45%", flexFlow: "row" }}>
        <label style={{ margin: "auto auto" }}>{game.H_Player}</label>
        <ScorePicker
          onChange={(n) => {
            game.home_goals = n;
            liveScoreStore.updateGame(game.id, game);
          }}
          size="Small"
          start={game.home_goals}
        />
      </div>
      <div
        style={{ width: "10%" }}
        onClick={() => {
          initCountdown();
        }}
      >
        VS
      </div>
      <div style={{ width: "45%", flexFlow: "row" }}>
        <label style={{ width: "60%" }}>{game.A_Player}</label>
        <ScorePicker
          onChange={(n) => {
            game.away_goals = n;
            liveScoreStore.updateGame(game.id, game);
          }}
          size="Small"
          start={game.away_goals}
        />
      </div>
    </div>
  );
};

// const PlayerScoreUdpater : React.FC<> = ()=> {
//     return ()
// }

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  height: "80vh",
  overflow: "hidden",
  p: 4,
};

const MultiLiveScoreUpdater = observer(_MultiLiveScoreUpdater);
export { MultiLiveScoreUpdater };
